import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  getItems,
  getWarehouses,
  addOpeningStock,
} from "../../services/apiService";
import "./OpeningStock.css";

export default function OpeningStock() {
  const [items, setItems] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    ItemID: "",
    WarehouseID: "",
    LotNumber: "",
    ExpiryDate: "",
    BoxQty: "1",
  });

  useEffect(() => {
    loadItems();
    loadWarehouses();
  }, []);

  const loadItems = async () => {
    try {
      const data = await getItems();

      setItems(
        data.map((i) => ({
          value: String(i.ItemId),
          label: `${i.CatalogNo} - ${i.ItemName || ""}`,
        }))
      );
    } catch (err) {
      console.error("LOAD ITEMS ERROR:", err);
    }
  };

  const loadWarehouses = async () => {
    try {
      const data = await getWarehouses();

      setWarehouses(
        data.map((w) => ({
          WarehouseID: String(w.warehouseId),
          WarehouseName: w.warehouseName,
        }))
      );
    } catch (err) {
      console.error("LOAD WAREHOUSES ERROR:", err);
    }
  };

  const isItemSelected = form.ItemID !== "";

  const handleSubmit = async () => {
    if (!form.ItemID || isNaN(Number(form.ItemID))) {
      alert("Please select a valid item");
      return;
    }

    if (!form.WarehouseID) {
      alert("Please select a warehouse");
      return;
    }

    if (!form.LotNumber.trim()) {
      alert("Lot number is required");
      return;
    }

    if (!form.BoxQty || Number(form.BoxQty) <= 0) {
      alert("Box quantity must be greater than 0");
      return;
    }

    try {
      setLoading(true);

      await addOpeningStock({
        ItemID: Number(form.ItemID),
        WarehouseID: Number(form.WarehouseID),
        LotNumber: form.LotNumber.trim(),
        ExpiryDate: form.ExpiryDate || null,
        BoxQty: Number(form.BoxQty),
      });

      alert("✅ Opening stock added successfully");

      setForm({
        ItemID: "",
        WarehouseID: "",
        LotNumber: "",
        ExpiryDate: "",
        BoxQty: "1",
      });
    } catch (err) {
      console.error("ADD OPENING STOCK ERROR:", err);
      alert("❌ Failed to add opening stock");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="opening-stock-page">
      <div className="opening-stock-header">
        <div>
          <h2>Opening Stock Entry</h2>
          <p>Register initial inventory stock by item, warehouse, lot, and expiry.</p>
        </div>
      </div>

      <div className="opening-stock-card">
        <div className="opening-stock-card-header">
          <div>
            <h3>Manual Stock Setup</h3>
            <span>Inventory Initialization Form</span>
          </div>
        </div>

        <div className="opening-stock-form">
          <div className="form-group full-width">
            <label>Item</label>
            <Select
              classNamePrefix="opening-select"
              options={items}
              value={items.find((i) => i.value === form.ItemID) || null}
              onChange={(opt) =>
                setForm({
                  ...form,
                  ItemID: opt ? opt.value : "",
                  WarehouseID: "",
                })
              }
              placeholder="Search and select item..."
              menuPosition="absolute"
              isClearable
            />
            <small className={isItemSelected ? "helper success" : "helper error"}>
              {isItemSelected
                ? "Item selected successfully."
                : "Please select an item first before entering stock details."}
            </small>
          </div>

          <div className="form-group">
            <label>Warehouse</label>
            <select
              disabled={!isItemSelected}
              value={form.WarehouseID}
              onChange={(e) =>
                setForm({
                  ...form,
                  WarehouseID: e.target.value,
                })
              }
            >
              <option value="">Select warehouse</option>
              {warehouses.map((w) => (
                <option key={w.WarehouseID} value={w.WarehouseID}>
                  {w.WarehouseName}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Box Quantity</label>
            <input
              type="number"
              min="1"
              disabled={!isItemSelected}
              value={form.BoxQty}
              onChange={(e) => setForm({ ...form, BoxQty: e.target.value })}
              placeholder="Enter box quantity"
            />
          </div>

          <div className="form-group">
            <label>Lot Number</label>
            <input
              type="text"
              disabled={!isItemSelected}
              value={form.LotNumber}
              onChange={(e) => setForm({ ...form, LotNumber: e.target.value })}
              placeholder="Enter lot number"
            />
          </div>

          <div className="form-group">
            <label>Expiry Date</label>
            <input
              type="date"
              disabled={!isItemSelected}
              value={form.ExpiryDate}
              onChange={(e) => setForm({ ...form, ExpiryDate: e.target.value })}
            />
          </div>
        </div>

        <div className="opening-stock-actions">
          <button
            className="save-btn"
            onClick={handleSubmit}
            disabled={!isItemSelected || loading}
          >
            {loading ? "Saving..." : "Add Opening Stock"}
          </button>
        </div>
      </div>
    </div>
  );
}